<template>
    <div ref="qrcode" slot="pdf-content" v-show="false">
        <div ref="qrcode_print"></div>
        <h1 class="mt-4">{{ qrcodeText }}</h1>
    </div>
</template>

<script>
    import * as qrCode from 'easyqrcodejs'
    export default {
        props: {
            qrcodeText: {
                type: String,
            },
        },
        methods: {
            download () {
                let mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

                mywindow.document.write(`<html><head><title>QR Convite</title>`);
                mywindow.document.write('</head><body>');
                mywindow.document.write(this.$refs.qrcode.innerHTML);
                mywindow.document.write('</body></html>');

                mywindow.document.close();
                mywindow.focus();
                setTimeout(() => {
                    mywindow.print();
                    setTimeout(() => {
                        mywindow.close();
                    }, 200);
                }, 200);
            },
        },
        mounted () {
            this.qrCodePrintDrawn = new qrCode(this.$refs.qrcode_print, {
                text: this.qrcodeText,
                width: 860,
                height: 860,
                quietZone: 0,
                quietZoneColor: 'transparent',
            });
        },
    }
</script>
